import { render, staticRenderFns } from "./ModalArgEdit.vue?vue&type=template&id=3fa3bb3c&scoped=true"
import script from "./ModalArgEdit.vue?vue&type=script&lang=js"
export * from "./ModalArgEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalArgEdit.vue?vue&type=style&index=0&id=3fa3bb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa3bb3c",
  null
  
)

export default component.exports